import React, {useMemo} from 'react';
import './BackView.css'
import { ReactComponent as LDrone } from "../assets/icons/d-2.svg";

const BackView = () => {

    const floating = useMemo(() => {
        const count = 10;
        const rnd = (min, max) => Math.random() * (max - min) + min;

        // зоны: верх/низ, чтобы не перекрывать центр (где текст и кнопки)
        const zones = [
            { topMin: 6, topMax: 28 },   // верх
            { topMin: 72, topMax: 94 },  // низ
            { topMin: 30, topMax: 45 },  // верхняя середина
            { topMin: 55, topMax: 70 },  // нижняя середина
        ];

        return Array.from({ length: count }, (_, i) => {
            const z = zones[i % zones.length];

            return {
                id: `drone-${i}`,
                left: `${rnd(6, 94)}%`,
                top: `${rnd(z.topMin, z.topMax)}%`,
                opacity: rnd(0.05, 0.12),
                scale: rnd(0.35, 0.95),
                rotate: rnd(-18, 18),
                dx: `${rnd(-180, 180)}px`,
                dy: `${rnd(-120, 120)}px`,
                dur: `${rnd(14, 28)}s`,
                delay: `${rnd(0, 8)}s`,
                wobbleDur: `${rnd(3.5, 7.5)}s`,
            };
        });
    }, []);
    return (
      <>
          <div className="heroGradient"/>
          <div className="heroGrid"/>
          <div className="heroFloatingLayer" aria-hidden="true">
              {floating.map((p) => (
                  <LDrone
                      key={p.id}
                      className="heroFloatIcon"
                      style={{
                          left: p.left,
                          top: p.top,
                          opacity: p.opacity,
                          transform: `translate(-50%, -50%) scale(${p.scale}) rotate(${p.rotate}deg)`,
                          "--dx": p.dx,
                          "--dy": p.dy,
                          "--dur": p.dur,
                          "--delay": p.delay,
                          "--wobbleDur": p.wobbleDur,
                      }}
                  />

              ))}
          </div>
      </>
)
    ;
};

export default BackView;
